import { Grid, Tabs } from '@mantine/core';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router';
import Metadata from '../../components/Metadata';
import SettingsTabAWS from '../../components/Settings/Tabs/SettingsTabAWS';
import { Page, SettingsDomainTabs } from '../../constants/pageTitles';

const tabs = ['storage'];
const SettingAWSPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const search = queryString.parse(location.search);
  let tab = search.tab || tabs[0];

  const setTab = (tab) => {
    navigate(location.pathname.replace(`/settings/aws`, `/settings/aws?tab=${tab}`));
  };

  return (
    <div>
      <Metadata title={`${Page['settings']} | ${SettingsDomainTabs[tab]}`} />

      <Grid pt={30} my={20}>
        <Grid.Col span={12}>
          <Tabs value={tab} onChange={setTab} mb="md" keepMounted>
            <Tabs.List>
              <Tabs.Tab value="storage">S3</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="storage">
              <SettingsTabAWS />
            </Tabs.Panel>
          </Tabs>
        </Grid.Col>
      </Grid>
    </div>
  );
};

export default SettingAWSPage;
